import numberFieldProps from './numberFieldProps';

export default numberFieldProps;
